import Vue from 'vue'
import Router from 'vue-router'
import {constructRoutes} from '@/methods/utils'

Vue.use(Router)

//存放全部路由信息
const allRouters = [];
// 存放所有路由信息
export const asyncRoutes = [];
//默认权限，即不需要权限路由
export let constantRoutes = [];

// 菜单项默认数据
const defaultRouteItemMeta = {
  icon: 'el-icon-menu'
};


/**
 * 将source路由数据合并到target路由数据，包含递归children进行合并
 * @param {Array} sourceRouters 源路由数据，需要合并的数据
 * @param {Array} targetRouters 目标路由数据，源数据将合并到这里
 */
 export function mergeRouters(sourceRouters, targetRouters) {
  targetRouters = targetRouters || [];
  sourceRouters.forEach((item) => {
    //layoutHandler(item);

    let oldItem = targetRouters.filter(v => v.name === item.name)[0];
    // 判断路由是否已经存在，不存在则添加
    if (!oldItem) {
      if (item.meta) {
        item.meta.icon = item.meta.icon || defaultRouteItemMeta.icon;
      }
      targetRouters.push(item);
      return;
    } else {
      // 合并子路由
      if (oldItem.children) {
        // 这里将合并后的子路由数据给item，是为了后面更新路由数据不被覆盖
        item.children = mergeRouters(oldItem.children, item.children);
      }

      // 更新当前对象值
      oldItem = Object.assign(oldItem, item);
    }
  });

  // 菜单进行排序
  targetRouters = targetRouters.sort((item1, item2) => {
    // 返回负值，交互顺序。此次为正序排列
    return item2.orderBy < item1.orderBy;
  });
  return targetRouters;
}

const router = new Router({
  mode:'hash',  //hash 或者 history
  base: process.env.BASE_URL,  //设置上下文根，不致于被路由替换
  routes: allRouters
});
// 合并模块的路由,合并前会检测数据中的useLayout字段，如果为true则绑定当前设置的layout
export function addRoutes(moduleName, moduleRouter) {

  if (moduleRouter && Array.isArray(moduleRouter) && moduleRouter.length > 0) {
    mergeRouters(moduleRouter, allRouters);
  }
  allRouters.forEach((element)=>{
    //console.log(element);
    router.addRoute(element);
  });
}

export function addRouteObj(selfRouters){
  const arr = constructRoutes(selfRouters);
  arr.forEach((element)=>{
    router.addRoute(element);
  });
  console.log(router.matcher.getRoutes());
}
export function addSingleRoute(singleRouters){
  router.addRoute(singleRouters);
  console.log(router.matcher.getRoutes());
}
router.beforeEach((to, from ,next)=>{
  const easyToken= localStorage.getItem('easyToken');
  
  if(!easyToken && to.path!="/tjmain" ){
    console.log("tjmain");
    return next("/tjmain");
  }
  next();
  
});

export default router;
